import React, { type FunctionComponent } from 'react'
import { type Styles } from 'react-select'
import { SimpleSelect, type SimpleSelectProps } from '@retailer-platform/shared-components'
import { type AccessControlConfig } from 'legacy/common/accessControl/accessControl.types'
import { useDomainMessages } from 'domains/products/utils/domain/intl'
import { SearchTypes } from 'domains/products/components/search/productSearch.constants'
import { useDomainAccessControl } from 'domains/products/utils/domain/accessControl'
import { instacartInternalAccessControl } from 'domains/products/access-control/searchAccess.configuration'

interface ProductsSearchTypeSelectProps extends Omit<SimpleSelectProps<string>, 'options'> {}

const searchTypeStyles: Styles = {
  control: () => ({
    height: 40,
  }),
}

export const ProductsSearchTypeSelect: FunctionComponent<ProductsSearchTypeSelectProps> = props => {
  const hasAccess = useDomainAccessControl()
  const hasAccessToProductId = hasAccess(instacartInternalAccessControl as AccessControlConfig)

  const i18n = useDomainMessages({
    name: 'productsDomain.search.columns.name',
    rrc: 'productsDomain.search.columns.rrcsku',
    upc: 'productsDomain.search.columns.upc',
    productId: 'productsDomain.search.columns.productId',
  })

  const searchTypeOptions = [
    { value: SearchTypes.Name, label: i18n.name },
    { value: SearchTypes.RRC, label: i18n.rrc },
    { value: SearchTypes.UPC, label: i18n.upc },
  ]

  if (hasAccessToProductId) {
    searchTypeOptions.push({ value: SearchTypes.ProductId, label: i18n.productId })
  }

  return (
    <SimpleSelect
      isModernTheme
      styles={searchTypeStyles}
      value={props.value}
      options={searchTypeOptions}
      onChange={props.onChange}
      {...props}
    />
  )
}
